<template>
  <AbstractFilters :filters="filters"
                   :on-click="filter"
                   :selected-filter="communityFilter"
  />
</template>
<script>
import AbstractFilters from './AbstractFilters'

export default {
  name: 'CommunityFilters',
  components: { AbstractFilters },
  created () {
    if (!this.$store.getters.communityFilter) {
      this.$store.dispatch('filterCommunities', 'all')
    }
  },
  methods: {
    filter (name) {
      this.$store.dispatch('filterCommunities', name)
    }
  },
  computed: {
    communityFilter () {
      return this.$store.getters.communityFilter
    },
    filters() {
      return [
        { name: this.$t('filter.communityFilters.all'), value: 'all' },
        { name: this.$t('filter.communityFilters.myCommunities'), value: 'myCommunities' },
        { name: this.$t('filter.communityFilters.myCreatedCommunities'), value: 'myCreatedCommunities' },
        { name: this.$t('filter.communityFilters.myJoinedCommunities'), value: 'myJoinedCommunities' }
      ]
    }
  }
}
</script>
